import {
  Box,
  Button,
  Collapse,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import leadFormStyles from "../Leads Page/leadFormStyles.module.css";
import { useNavigate } from "react-router-dom";
import { GET_GROUP_MEETING_LIST } from "../../constants";
import axios from "axios";
import FilterListIcon from "@mui/icons-material/FilterList";
import dayjs from "dayjs";
import ModalComponent from "../reusable Component/modalComponent";

const buttonStyle = {
  border: "1px solid #fff",
  borderRadius: "4px",
  margin: "5px",
  width: "40px",
  height: "40px",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#097969",
  color: "#fff",
  transition: "background-color 0.3s, transform 0.2s",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
};

const hoverEffects = (e, isHovering) => {
  e.currentTarget.style.backgroundColor = isHovering ? "#0B9B73" : "#097969";
  e.currentTarget.style.transform = isHovering ? "scale(1.05)" : "scale(1)";
};

const GroupMeetingComponent = ({}) => {
  const [row, setRow] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(
    dayjs().subtract(1, "day").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    dayjs().subtract(1, "day").format("YYYY-MM-DD")
  );
  const [filterShow, setFilterShow] = useState(false);
  const [meetingData, setMeetingData] = useState([]);

  const navigate = useNavigate();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchGroupMeetingData = async (startDate, endDate) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${GET_GROUP_MEETING_LIST}/${localStorage.getItem(
          "username"
        )}?startDate=${startDate}&endDate=${endDate}`
      );
      setMeetingData(response.data.meetings);
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroupMeetingData(startDate, endDate);
  }, []);

  const handleApply = () => {
    fetchGroupMeetingData(startDate, endDate); // Fetch data for the selected date range
    setFilterShow(false);
  };

  const handleClear = () => {
    const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");
    setStartDate(yesterday); // Reset to yesterday
    setEndDate(yesterday); // Reset to yesterday
    fetchGroupMeetingData(yesterday, yesterday);

    setFilterShow(false);
  };

  const handleRowClick = (index) => {
    const newExpandedRows = expandedRows.includes(index)
      ? expandedRows.filter((i) => i !== index)
      : [...expandedRows, index];
    setExpandedRows(newExpandedRows);
  };

  const [participantMobNo, setParticipantMobNo] = useState('');

  const rowExpansionTemplate = (data) => (
    <Grid
      container
      spacing={2}
      p={2}
      sx={{ backgroundColor: "#f9f9f9", borderRadius: 2, width: "100%", margin: 0 }}
    >
      {/* Participants List */}
      {data.participants?.length > 0 ? (
        data.participants.map((participant, index) => (
          <Grid
            container
            key={participant.id}
            spacing={1}
            p={2}
            xs={12} // Ensures full width
            sx={{
              backgroundColor: "#fff",
              borderRadius: 2,
              marginBottom: 2,
              width: "100%",
              marginLeft: 0,
            }}
          >
            {/* Participant Number */}
            <Grid item xs={12}>
              <Typography variant="body1" fontWeight="bold" color="secondary">
                Participant {index + 1}
              </Typography>
            </Grid>
  
            {/* Participant Details */}
            <Grid item xs={6}>
              <Typography variant="body2">
                <strong>Name:</strong> {participant.customer_name}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">
                <strong>Mobile:</strong> {participant.mobile}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">
                <strong>Location:</strong> {participant.location}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">
                <strong>Pincode:</strong> {participant.pincode}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2">
                <strong>Unique:</strong>{" "}
                <span style={{ color: participant.is_unique ? "green" : "red", fontWeight: "bold" }}>
                  {participant.is_unique ? "Yes" : "No"}
                </span>
              </Typography>
            </Grid>
  
            {/* Action Buttons */}
           {participant.is_unique && ( <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() =>{ 
                  setOpen(true)
                setParticipantMobNo(participant.mobile)}}
              >
                Convert
              </Button>
              
            </Grid>)}
          </Grid>
        ))
      ) : (
        <Grid item xs={12}>
          <Typography variant="body2" color="textSecondary">
            No participants available
          </Typography>
        </Grid>
      )}
    </Grid>
  );
  
  
   const [open, setOpen] = useState(false);
    const [editMobNo, setEditMobNo] = useState("");
     const [openSnackbar, setOpenSnackbar] = useState(false);
      const [severity, setSeverity] = useState("");
      const [message, setMessage] = useState("");
  
  

  const handleClickOpen = () => {
    navigate("/groupMeeting/add");
  };

  return (
    <>
      <Box
        sx={{
          display: "flex", // Use flexbox for layout
          alignItems: "center", // Center vertically
          gap: "16px", // Add space between boxes
          mb: 2, // Bottom margin
        }}
      >
        <Box
          sx={{
            display: "flex", // Use flexbox for layout
            flexWrap: "wrap", // Allow wrapping for responsiveness
            gap: "16px", // Add space between boxes
            flexGrow: 1, // Let this container take up remaining space
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: 1 }}>
            Group Meeting
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 1, // Space between items
          }}
        >
          {filterShow && (
            <Box
              sx={{
                backgroundColor: "#f0f4f8",
                padding: 1,
                borderRadius: 2,
                boxShadow: 3,
                width: "100%",
              }}
            >
              <Grid container spacing={2}>
                {/* Start Date Picker */}
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Start Date"
                    type="date"
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </Grid>

                {/* End Date Picker */}
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="End Date"
                    type="date"
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </Grid>

                {/* Action Buttons */}
                <Grid item xs={12} sm={3}>
                  <Box sx={{ display: "flex" }}>
                    <Button
                      onClick={handleClear}
                      variant="outlined"
                      color="secondary"
                      sx={{ marginRight: 2 }}
                    >
                      Clear
                    </Button>
                    <Button
                      onClick={handleApply}
                      variant="contained"
                      color="primary"
                    >
                      Apply
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )}

          {/* Filter Icon */}
          <div>
            <IconButton
              onClick={() => setFilterShow((prev) => !prev)}
              style={buttonStyle}
              onMouseEnter={(e) => hoverEffects(e, true)}
              onMouseLeave={(e) => hoverEffects(e, false)}
            >
              <FilterListIcon />
            </IconButton>
          </div>
        </Box>

        {/* <Button
          variant="outlined"
          onClick={handleClickOpen}
          sx={{
            fontSize: "1rem",
            fontWeight: "700",
            borderWidth: "1.5px",
            marginLeft: "auto", // Push button to the far right
          }}
        >
          + Add Group
        </Button> */}
      </Box>

      <Paper>
        <TableContainer
          sx={{
            boxShadow: 2,
            borderRadius: "8px",
            margin: "8px 0",
          }}
        >
          <Table
            sx={{
              minWidth: 250,
              height: "100%",
              tableLayout: "fixed", // Ensures equal column width distribution
            }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
                <TableCell
                  align="left"
                  sx={{
                    padding: 0,
                    fontWeight: "bold",
                    width: 10,
                  }}
                ></TableCell>
                <TableCell
                  align="left"
                  sx={{
                    padding: 1,
                    width: 30,
                    fontWeight: "bold",
                  }}
                >
                  SNo
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    padding: 1,
                    fontWeight: "bold",
                  }}
                >
                  Group Id
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    padding: 1,
                    fontWeight: "bold",
                  }}
                >
                  Group Name
                </TableCell>
                {/* <TableCell
                  align="center"
                  sx={{
                    padding: 1,
                    fontWeight: "bold",
                    backgroundColor: "#EEF0F4",
                  }}
                >
                  Action
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {meetingData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No Data Available Yet.
                  </TableCell>
                </TableRow>
              ) : (
                meetingData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <React.Fragment key={row.SNo}>
                      <TableRow sx={{ cursor: "pointer" }}>
                        {/* Expand Action */}
                        <TableCell align="left" sx={{ padding: 0 }}>
                          <button onClick={() => handleRowClick(index)}>
                            {expandedRows.includes(index) ? (
                              <ArrowDropDownIcon />
                            ) : (
                              <ArrowRightIcon />
                            )}
                          </button>
                        </TableCell>

                        {/* Other Columns */}
                        <TableCell align="center">
                          {/* {filters.page * filters.pageSize + index + 1} */}
                          {index + 1}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ wordBreak: "break-word" }}
                        >{row.group_id}</TableCell>
                        <TableCell
                          align="center"
                          sx={{ textDecoration: "none" }}
                        >{row.group_meeting_title}</TableCell>
                        {/* <TableCell
                          align="center"
                          sx={{ backgroundColor: "#EEF0F4" }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          ></Box>
                        </TableCell> */}
                      </TableRow>

                      {/* Collapse Row */}
                      {expandedRows.includes(index) && (
                        <TableRow>
                          <TableCell colSpan={4} sx={{ padding: 0 }}>
                            <Collapse in={expandedRows.includes(index)}>
                              <Box
                                sx={{
                                  overflowX: "auto", // Add horizontal scrolling if content exceeds container width
                                }}
                              >
                                {rowExpansionTemplate(row)}
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={row.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 20, 25]}
        />
      </Paper>

      {/* Add Lead Modal */}
            <ModalComponent
              open={open}
              modalTitle={"BDM Lead Generation"}
              setOpen={setOpen}
              rowDetails={{}}
              setOpenSnackbar={setOpenSnackbar}
              setSeverity={setSeverity}
              setMessage={setMessage}
              setEditMobNo={setEditMobNo}
              place={"Group"}
              ParticipantMobNo={participantMobNo}
            ></ModalComponent>
    </>
  );
};

export default GroupMeetingComponent;
